export const fetchCountry = async () => {
    const requestOptions = {
      method: 'GET',
    };
  
    try {
      const response = await fetch('https://pro.ip-api.com/json?key=KNngkXfQyTmyYJk', requestOptions);
      const data = await response.json();
      return data.country;
    } catch (error) {
      console.error('Error fetching country:', error);
      throw error;
    }
  };
  